import React from 'react'
import {
    AssignPatientToNewCareProgram,
    DeleteCustomWorklist,
    ExportSummary,
    ManageReferral,
    MarkAsOutreached,
    NewAssessmentFlow,
    NewAssessmentTemplateSelector,
    PatientAlreadyRemovedWarning,
    ReassignCareStepModal,
    RemovePatientFromWorklist,
    SaveAsCustomWorklist,
    SnoozedModal,
    ViewAs,
    WorkOnCareStep
} from './modalsComponents'

const Modals = () => {
  return (
    <>
      <SnoozedModal />
      <WorkOnCareStep />
      <AssignPatientToNewCareProgram />
      <RemovePatientFromWorklist />
      <PatientAlreadyRemovedWarning />
      <ExportSummary />
      <SaveAsCustomWorklist />
      <DeleteCustomWorklist />
      <ManageReferral />
      <NewAssessmentTemplateSelector />
      <NewAssessmentFlow />
      <ReassignCareStepModal />
      <ViewAs />
      <MarkAsOutreached />
    </>
  )
}

export default Modals